<template>
  <div class="skeleton-category-page">
    <the-skeleton class="skeleton-category-page__breadcrumbs" radius="8" />

    <the-skeleton class="skeleton-category-page__title" radius="8" />

    <the-skeleton
      class="skeleton-category-page__text"
      width="100%"
      height="42"
      radius="8"
    />

    <div class="skeleton-category-page__filters">
      <the-skeleton
        v-for="index in 8"
        :key="index"
        width="100"
        height="40"
        radius="100"
      />
    </div>

    <div class="skeleton-category-page__products">
      <the-skeleton
        v-for="index in 8"
        :key="index"
        class="skeleton-category-page__product"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.skeleton-category-page {
  &__breadcrumbs {
    width: 160px;
    height: 24px;
    margin-bottom: 20px;

    @include media('>=desktop-mini') {
      width: 320px;
      height: 16px;
    }
  }

  &__title {
    width: 240px;
    height: 21px;
    margin-bottom: 25px;

    @include media('>=desktop-mini') {
      width: 440px;
      height: 42px;
      margin-bottom: 30px;
    }
  }

  &__text {
    display: none;

    @include media('>=desktop-mini') {
      display: block;
      margin-bottom: 30px;
    }
  }

  &__filters {
    display: none;

    @include media('>=desktop-mini') {
      display: flex;
      gap: 10px;
      margin-bottom: 30px;
    }
  }

  &__products {
    display: grid;
    grid-template-columns: repeat(2, minmax(145px, 1fr));
    gap: 10px;

    @include media('>=desktop-mini') {
      grid-template-columns: repeat(auto-fit, 276px);
      gap: 100px 32px;
    }
  }

  &__product {
    height: 248px;
    border-radius: 16px;

    @include media('>=desktop-mini') {
      height: 392px;
      border-radius: 25px;
    }
  }
}
</style>
